export const ORGANIZATION_TABS = ['requisites', 'invites', 'users', 'pricing'];

export const CLIENT_TABS = ['requisites', 'applicants'];
